import React, { useEffect } from "react";
import { Box, Spinner, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { authSubsPost } from "src/api/authSubs";
import { useDispatch } from "src/store";
import { logout } from "src/store/auth";

const Logout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const logoutUser = async () => {
      //send a request to inform the server that the user logged out from a device
      //call it first cause it uses the token stored in local storage, logout() removes it!
      await authSubsPost("/auth/logout", {});
      dispatch(logout());
      window.localStorage.removeItem("_sal-Calibra");
      window.localStorage.removeItem("userEmail");
    };
    logoutUser();
  }, [dispatch]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingTop="250px"
    >
      <Spinner size="md" />
      <Text margin="0 10px" color="grey">
        <FormattedMessage id="loggingOut" />
      </Text>
    </Box>
  );
};

export default Logout;
